export const routes = {
  'discover-rolex': {
    en: '/',
    de: '/'
  },
  'watches': {
    en: '/watches',
    de: '/uhren'
  },
  'new-watches-2024': {
    en: '/new-watches-2024',
    de: '/neue-uhren-2024'
  },
  'new-watches-2025': {
    en: '/new-watches-2025',
    de: '/neue-uhren-2025'
  },
  'watchmaking': {
    en: '/watchmaking',
    de: '/uhrmacherkunst'
  },
  'servicing': {
    en: '/servicing',
    de: '/service'
  },
  'servicing-procedure': {
    en: '/servicing-procedure',
    de: '/service-prozedur'
  },
  'world-of-rolex': {
    en: '/world-of-rolex',
    de: '/welt-von-rolex'
  },
  'contact-us': {
    en: '/contact-us',
    de: '/kontakt'
  },
  'send-message': {
    en: '/contact-us/send-message',
    de: '/kontakt/nachricht-senden'
  },
  'rolex-at': {
    en: '/rolex-at',
    de: '/rolex-bei'
  },
  'showrooms': {
    en: '/showrooms',
    de: '/raumlichkeiten'
  },
  'team': {
    en: '/team',
    de: '/team'
  },
  'history': {
    en: '/history',
    de: '/geschichte'
  }
}
